import { all } from "redux-saga/effects";
import creditApplicationSaga from "./creditApplication";

export default function* buyerCreditSaga() {
  yield all([creditApplicationSaga()]);
}
